var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReceiptsPhysicalCards = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7 62.6996C61.9489 62.6996 73.4999 51.1486 73.4999 36.8996C73.4999 22.6507 61.9489 11.0996 47.7 11.0996C33.451 11.0996 21.8999 22.6507 21.8999 36.8996C21.8999 51.1486 33.451 62.6996 47.7 62.6996Z",
    fill: "#FECBBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.39941L5.89996 5.4994L10.4 1.4994L14.8 5.4994L19.4 1.4994L23.7 5.4994L28.1 1.4994L32.5 5.4994L36.9 1.4994L41.4 5.29941L45.6 1.39941L50 5.4994L54.5 1.4994V70.7994L50.1 66.6994L45.6 70.6994L41.1 66.7994L36.6 70.6994L32.3 66.6994L27.9 70.6994L23.5 66.7994L19 70.6994L14.6 66.8994L10.4 70.7994L6 66.6994L1.5 70.6994V1.39941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 38.7998L31.8002 38.8998",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7002 38.7998H41.0002",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 47.8994L31.8998 47.9994",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7998 47.8994H41.1998",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 56.999L31.9998 57.099",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7998 56.8994L41.1998 56.9994",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6 28.1996H20.7C20 28.1996 19.5 27.6996 19.5 26.9996V15.2996C19.5 14.5996 20 14.0996 20.7 14.0996H34.6C35.3 14.0996 35.8 14.5996 35.8 15.2996V26.9996C35.8 27.6996 35.2 28.1996 34.6 28.1996Z",
    fill: "#FFCBBD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9001 17.1994C25.9001 17.2994 25.5001 17.6994 25.5001 18.3994C25.5001 18.6994 25.6001 18.8994 25.8001 19.0994C26.0001 19.2994 26.4001 19.3994 26.9001 19.5994L28.6001 20.0994C30.0001 20.5994 31.0001 21.0994 31.6001 21.5994C32.2001 22.0994 32.5001 22.7994 32.5001 23.6994C32.5001 24.6994 32.1001 25.4994 31.4001 26.0994C30.7001 26.6994 29.7001 27.0994 28.5001 27.1994V29.0994H26.8001V27.1994C25.8001 27.0994 25.0001 26.7994 24.2001 26.2994C23.5001 25.8994 22.9001 25.3994 22.6001 24.9994L23.6001 22.7994H23.7001C24.0001 23.1994 24.4001 23.5994 24.9001 23.9994C25.4001 24.3994 26.0001 24.6994 26.7001 24.8994C26.7001 24.8994 27.3001 25.1994 28.4001 25.0994C29.5001 24.9994 29.9001 24.5994 29.9001 23.7994C29.9001 23.4994 29.8001 23.2994 29.5001 23.0994C29.3001 22.8994 28.9001 22.6994 28.3001 22.4994L26.6001 21.8994C26.2001 21.6994 25.8001 21.5994 25.7001 21.5994C25.5001 21.4994 25.3001 21.3994 24.9001 21.2994C24.6001 21.1994 24.3001 20.9994 24.2001 20.8994C24.1001 20.7994 23.9001 20.6994 23.7001 20.4994C23.5001 20.2994 23.3001 20.1994 23.2001 19.9994C23.1001 19.7994 23.0001 19.5994 23.0001 19.3994C22.9001 19.1994 22.9001 18.8994 22.9001 18.5994C22.9001 17.5994 23.2001 16.7994 23.9001 16.1994C24.6001 15.4994 25.5001 15.1994 26.7001 15.0994V13.3994H28.4001V15.1994C29.2001 15.3994 29.9001 15.6994 30.5001 16.0994C31.1001 16.4994 31.5001 16.8994 31.8001 17.3994L30.6001 19.3994H30.5001C30.3001 18.9994 30.0001 18.6994 29.6001 18.2994C29.2001 17.8994 28.8001 17.6994 28.3001 17.5994C28.6001 17.3994 27.8001 17.0994 26.9001 17.1994Z",
    fill: "#311D6C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 53.2994V1.39941L5.89996 5.4994L10.4 1.4994L14.8 5.4994L19.4 1.4994L23.7 5.4994L28.1 1.4994L32.5 5.4994L36.9 1.4994L41.4 5.29941L45.6 1.39941L50 5.4994L54.5 1.4994",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 13.0996V70.7996L50.1 66.6996L45.6 70.6996L41.1 66.7996L36.6 70.6996L32.3 66.6996L27.9 70.6996L23.5 66.7996L19 70.6996L14.6 66.8996L10.4 70.7996L6 66.6996L1.5 70.6996V63.1996",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReceiptsPhysicalCards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/receipts-physical-cards.b2bf5a03517de137a6fd72b36a2e801e.svg";